<template>
  <Buybox :product="data"/>
  <ProductStickyBar :product="data"/>
  <ProductCTL v-if="ctlProducts && ctlProducts.length" :products="ctlProducts"/>
</template>

<script setup>
  import { reactive, computed, onMounted, onUnmounted } from 'vue';
  import {useStore} from "vuex";
  import Buybox from './components/buybox.vue';
  import ProductStickyBar from './components/product-sticky-bar.vue';
  import ProductCTL from './components/product-ctl.vue';

  const props = defineProps({
    data: {
      type: Object,
      default: () => ({})
    }
  })

  const store = useStore();
  const firstOption = reactive(props.data.options[0].name)
  const productForm = reactive(store.state.pdp.productForm)

  onMounted(() => {
    store.dispatch('fetchWishlistItems');
    window.addEventListener('refreshWishlist', refreshWishlist);
  })

  onUnmounted(() => {
    window.removeEventListener('refreshWishlist', refreshWishlist);
  });

  const refreshWishlist = () => {
    store.dispatch('fetchWishlistItems');
  };

  const ctlProducts = computed(() => {
    const { variants } = props.data;
    const selectedFirstOption = productForm[firstOption];

    if (!selectedFirstOption) {
      return [];
    }

    const selectedColorVariants = variants.filter(
      (variant) => variant.ctlProducts?.length > 0 && variant.option1 === selectedFirstOption
    );

    if (selectedColorVariants.length) {
      const filteredProducts = selectedColorVariants[0].ctlProducts
        .map((ctlProduct) => {
          const firstLevelOptions = ctlProduct.product.variants.reduce((set, variant) => {
            const property = variant.option1;
            const setItem = set[property] = set[property] || {};
            if (variant.available) setItem.available = true;
            return set;
          }, {});

          const isAvailable = firstLevelOptions[ctlProduct.selectedFirstOption]?.available;
          return isAvailable ? ctlProduct : null;
        })
        .filter(Boolean);

      return filteredProducts;
    }

    return [];
  });

</script>